import { inject, Injectable } from '@angular/core';
import { UnleashFlags, UnleashService } from '@thiememeulenhoff/ng-sdk';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class FeedbackEndpointsService {
  readonly #servicesService = inject(ServicesService);

  readonly #unleashService = inject(UnleashService);

  postEndpoint(arrangementCode: string) {
    if (this.#unleashService.isEnabled(UnleashFlags.CreateFeedbackThor)) {
      return this.#servicesService.thor(`feedback`);
    }

    return this.#servicesService.edition(
      `feedback/arrangement/${arrangementCode}`,
    );
  }

  postBody(
    actor: string,
    arrangementCode: string,
    contentPath: string,
    message: string,
  ) {
    if (this.#unleashService.isEnabled(UnleashFlags.CreateFeedbackThor)) {
      return {
        actor,
        arrangementCode,
        contentPath,
        message,
      };
    }

    const contentIdentifier = contentPath.split('/').pop();

    return {
      userReference: actor,
      message,
      contentIdentifier,
    };
  }

  getEndpointTeacher(
    actor: string,
    arrangementCode: string,
    contentPath: string,
  ) {
    const contentIdentifier = contentPath.split('/').pop();

    if (this.#unleashService.isEnabled(UnleashFlags.GetFeedbackThor)) {
      return this.#servicesService.thor(
        `feedback/actor/${actor}/arrangement/${arrangementCode}/content/${contentIdentifier}`,
      );
    }

    return this.#servicesService.edition(
      `feedback/arrangement/${arrangementCode}/${contentIdentifier}/user/${actor}`,
    );
  }

  getEndpointStudent(arrangementCode: string, contentPath: string) {
    const contentIdentifier = contentPath.split('/').pop();

    if (this.#unleashService.isEnabled(UnleashFlags.GetFeedbackThor)) {
      return this.#servicesService.thor(
        `feedback/arrangement/${arrangementCode}/content/${contentIdentifier}`,
      );
    }

    return this.#servicesService.edition(
      `feedback/arrangement/${arrangementCode}/${contentIdentifier}`,
    );
  }
}
